// extracted by mini-css-extract-plugin
export default {"root":"Dimensions_root__XBJO2","label":"Dimensions_label__hgBEH"};